import { isEmpty } from 'lodash'
import React, { useContext } from 'react'
import YouTube from 'react-youtube'
import NewCustomizedPlayer from './newCustomizedPlayer'
import CustomPlayer from '../player/customPlayer'
import { TemplateContext } from '../../context/template'
import { useNavigate } from 'react-router'

const ExternalLinkPlayer = (props) => {
  const navigate = useNavigate()
  const { playerTemplateData } = useContext(TemplateContext)
  const {
    youtubeData,
    contentInfo,
    resumeTime,
    handlePlayingSequence,
    adCampaignData,
    onVideoComplete,
    playerData,
    handleNext = null,
    handlePrev = null,
    stillWatchingAllowed = false,
    disableHeader = false,
    loop = false,
    controlBar = true,
  } = props
  const youtubeOptions = {
    height: '100%',
    width: '100%',
    playerVars: {
      rel: 0,
      autoplay: 1,
      // https://developers.google.com/youtube/player_parameters
    },
  }
  const handlePrevDefault = () => {
    if (window.history?.length && window.history.length > 1) {
      navigate(-1)
    }
  }
  return (
    <div className="w-full h-full">
      {youtubeData.type === 'YOUTUBE' && (
        <YouTube videoId={youtubeData?.video_id} opts={youtubeOptions} className="w-full h-full" />
      )}
      {(youtubeData.type === 'MP4' || youtubeData.type === 'HLS') &&
      !isEmpty(playerTemplateData?.data) ? (
        <NewCustomizedPlayer
          contentInfo={contentInfo}
          contentWatchUrl={youtubeData.link}
          resumeTime={resumeTime}
          handlePlayingSequence={handlePlayingSequence}
          adCampaignData={adCampaignData}
          onVideoComplete={onVideoComplete}
          playerData={playerData}
          handleNext={handleNext}
          handlePrev={handlePrev ? handlePrev : handlePrevDefault}
          stillWatchingAllowed={stillWatchingAllowed}
          isMp4={youtubeData.type === 'MP4'}
        />
      ) : (
        <CustomPlayer
          contentInfo={contentInfo}
          contentWatchUrl={youtubeData.link}
          resumeTime={resumeTime}
          handlePlayingSequence={handlePlayingSequence}
          disableHeader={disableHeader}
          loop={loop}
          controlBar={controlBar}
          adCampaignData={adCampaignData}
          onVideoComplete={onVideoComplete}
          handleNext={handleNext}
          handlePrev={handlePrev ? handlePrev : handlePrevDefault}
          stillWatchingAllowed={stillWatchingAllowed}
          isMp4={youtubeData.type === 'MP4'}
        />
      )}
    </div>
  )
}

export default ExternalLinkPlayer
